import { getField, updateField } from 'vuex-map-fields';

const localStorageKey = (path) => `airspirit-registration-${path.replaceAll('.', '-')}`

// Une valeur vidée a pu être enregistrée sous forme de chaîne ("null") par une
// ancienne version : on la traite comme une absence de valeur
const getFromLocalStorage = (path) => {
  const value = localStorage.getItem(localStorageKey(path))
  return (value === 'null' || value === 'undefined') ? null : value
}

const state = {
  // GLOBAL
  companyRegistrationStep: getFromLocalStorage('companyRegistrationStep') || 1,
  companyRegistrationSubStep: getFromLocalStorage('companyRegistrationSubStep') || 1,

  //// ------------ COMPANY -------------------
  company: {
    category: getFromLocalStorage('company.category') || null,
    name: '',
    user: {
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        passwordConfirmation: '',
    }
  }
}

const getters = {
  getField,
  getCompanyRegistrationForm: state => {
    return {
        categories: [{name: state.company.category}],
        operator_categories: [],
        qualifications: [],
        name: state.company.name,
        user: {
            first_name: state.company.user.firstName,
            last_name: state.company.user.lastName,
            username: state.company.user.username,
            password: state.company.user.password,
        }
    }
  }
}

const mutations = {
  updateFieldWithLocalStorage(state, field) {
    if (field.value === null || field.value === undefined) {
      localStorage.removeItem(localStorageKey(field.path))
    }
    else if (Array.isArray(field.value) || typeof field.value === 'boolean') {
      localStorage.setItem(localStorageKey(field.path), JSON.stringify(field.value))
    }
    else {
      localStorage.setItem(localStorageKey(field.path), field.value)
    }
    updateField(state, field);
  },
}

export default {
  state,
  getters,
  mutations,
}